var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import Input from '@fp-suite/core-ui/src/components/Input';
import Modal from '@fp-suite/core-ui/src/components/Modal';
import Button from '@fp-suite/core-ui/src/components/Button';
import { IoIosAddCircle } from 'react-icons/io';
import { BsCheckCircleFill } from 'react-icons/bs';
import { Form } from 'antd';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import ScanTotesForSinglePick from '../components/ScanTotesForSinglePick';
import ScanProduct from '../components/ScanProduct';
import ScanAgainLocation from '../components/ScanAgainLocation';
import PlaceInTote from '../components/PlaceInTote';
import Heading from '../components/Heading';
import { getScannedTote, getScannedLocation, pickMovePickContainer, updatePickRunStatus, updatePickrunDropzone } from '../redux/authSlice';
import MainHeading from '../components/MainHeading';
var PickMultis = function (_a) {
    var subscreenToBeSet = _a.subscreenToBeSet, scannedTotesList = _a.scannedTotesList, skipScanLocationScreen = _a.skipScanLocationScreen, setIsLoading = _a.setIsLoading;
    var form = Form.useForm()[0];
    var dispatch = useDispatch();
    var history = useHistory();
    var t = useTranslation().t;
    var isMobileDevice = useMediaQuery({
        query: '(max-device-width: 640px)'
    });
    var _b = useState(false), isModalVisible = _b[0], setModalVisible = _b[1];
    var _c = useState(false), scannedCartIncorrect = _c[0], setScannedCartIncorrect = _c[1];
    var _d = useState(subscreenToBeSet ? subscreenToBeSet : skipScanLocationScreen ? 'scanCart' : 'scanStartLocation'), currentActiveSubscreen = _d[0], setCurrentActiveSubscreen = _d[1];
    var _e = useState(scannedTotesList), totesList = _e[0], setTotesList = _e[1];
    var _f = useState(false), scannedToteIncorrect = _f[0], setScannedToteIncorrect = _f[1];
    var _g = useState(''), errorMsgText = _g[0], setErrorMsgText = _g[1];
    var _h = useState(false), scannedLocationIncorrect = _h[0], setScannedLocationIncorrect = _h[1];
    var _j = useState(false), scannedDropzoneLocationIncorrect = _j[0], setScannedDropzoneLocationIncorrect = _j[1];
    var _k = useState(false), scannedProdUpcIncorrect = _k[0], setScannedProdUpcIncorrect = _k[1];
    var _l = useState(false), isToteScanned = _l[0], setIsToteScanned = _l[1];
    var _m = useState(''), cartScannedData = _m[0], setCartScannedData = _m[1];
    var _o = useState(''), toteScanInput = _o[0], setToteScanInput = _o[1];
    var _p = useState(''), cartScanInput = _p[0], setCartScanInput = _p[1];
    var _q = useState(''), scannedLocationInput = _q[0], setScannedLocationInput = _q[1];
    var _r = useState(''), setScannedFinalToteInput = _r[1];
    var _s = useState(''), setScanLocationInput = _s[1];
    var _t = useState(''), setScannedDropzoneLocationInput = _t[1];
    var _u = useState(''), scannedDropzoneTotesInput = _u[0], setScannedDropzoneTotesInput = _u[1];
    var _v = useState(false), setExceptionConfirmed = _v[1];
    var _w = useState(''), setExceptionType = _w[1];
    var enumTypeList = [];
    var _x = useState(''), setExceptionTypeEnumId = _x[1];
    var _y = useState([]), checkedContainers = _y[0], setCheckedContainers = _y[1];
    var _z = useState(true), continuePickMovePickContainer = _z[0], setContinuePickMovePickContainer = _z[1];
    var requiredPickContainerCount = localStorage.getItem('requiredPickContainerCount');
    requiredPickContainerCount *= 1;
    var parsedContainers = localStorage.getItem('pickRunContainerList');
    parsedContainers = JSON.parse(parsedContainers);
    useEffect(function () {
        form.validateFields(['scannedCart', 'scannedTote']); // eslint-disable-next-line
    }, [isToteScanned]);
    var onCartScan = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.key === 'Enter')) return [3 /*break*/, 2];
                    form.setFieldsValue({
                        scannedCart: ''
                    });
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedLocation({
                            scanLocationId: event.target.value,
                            setScannedLocationIncorrect: setScannedCartIncorrect,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromScreen: 'scanCart',
                            subscreenName: 'scanTotes',
                            setErrorMsgText: setErrorMsgText,
                            setTotesList: setTotesList,
                            totesList: totesList
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    setScannedCartIncorrect(false);
                    setCartScanInput(event.target.value);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onToteScan = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.key === 'Enter')) return [3 /*break*/, 2];
                    form.setFieldsValue({
                        scannedTote: ''
                    });
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedLocation({
                            scanLocationId: event.target.value,
                            setScannedLocationIncorrect: setScannedToteIncorrect,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            subscreenName: 'scanLocation',
                            setErrorMsgText: setErrorMsgText,
                            fromScreen: 'scanTote',
                            totesList: totesList,
                            setTotesList: setTotesList
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    setToteScanInput('');
                    return [3 /*break*/, 3];
                case 2:
                    setIsToteScanned(false);
                    setScannedToteIncorrect(false);
                    setToteScanInput(event.target.value);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onStartLocationScan = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.key === 'Enter')) return [3 /*break*/, 2];
                    form.setFieldsValue({
                        scannedStartLocation: ''
                    });
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedLocation({
                            scanLocationId: event.target.value,
                            setScannedLocationIncorrect: setScannedLocationIncorrect,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromScreen: 'scanStartLocation',
                            subscreenName: 'scanCart',
                            setErrorMsgText: setErrorMsgText,
                            totesList: totesList,
                            setTotesList: setTotesList,
                            pickRunTypeId: 'PrtMulti'
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    setScannedLocationInput('');
                    return [3 /*break*/, 3];
                case 2:
                    setScannedLocationIncorrect(false);
                    setScannedLocationInput(event.target.value);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onLocationScan = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.key === 'Enter')) return [3 /*break*/, 2];
                    form.setFieldsValue({
                        scanLocationData: ''
                    });
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedLocation({
                            scanLocationId: event.target.value,
                            setScannedLocationIncorrect: setScannedLocationIncorrect,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromScreen: 'scanLocationAgain',
                            subscreenName: 'scanProductUpc',
                            setErrorMsgText: setErrorMsgText,
                            totesList: totesList,
                            setTotesList: setTotesList
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    setScanLocationInput('');
                    return [3 /*break*/, 3];
                case 2:
                    setScannedLocationIncorrect(false);
                    setScanLocationInput(event.target.value);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onProductUpcScan = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.key === 'Enter')) return [3 /*break*/, 2];
                    form.setFieldsValue({
                        scanProdUpc: ''
                    });
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedLocation({
                            scanLocationId: event.target.value,
                            setScannedLocationIncorrect: setScannedProdUpcIncorrect,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromScreen: 'prodUpcScreen',
                            subscreenName: 'placeInTote',
                            setErrorMsgText: setErrorMsgText,
                            totesList: totesList,
                            setTotesList: setTotesList
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    setTotesList([]);
                    return [3 /*break*/, 3];
                case 2:
                    setScannedProdUpcIncorrect(false);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onScanToteClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.key === 'Enter')) return [3 /*break*/, 2];
                    form.setFieldsValue({
                        scanFinalToteInput: ''
                    });
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedTote({
                            scanToteId: event.target.value,
                            setScannedToteIncorrect: setScannedToteIncorrect,
                            totesList: totesList,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            setErrorMsgText: setErrorMsgText,
                            setTotesList: setTotesList,
                            setIsToteScanned: setIsToteScanned,
                            isFromFinalStep: false,
                            fromMoveToSortingScreen: false,
                            subscreenName: 'scanDropzoneLocation'
                        }))];
                case 1:
                    _a.sent();
                    setScannedFinalToteInput('');
                    setIsLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    setScannedToteIncorrect(false);
                    setScannedFinalToteInput(event.target.value);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onScanDropzoneLocationClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.key === 'Enter')) return [3 /*break*/, 2];
                    form.setFieldsValue({
                        scanDropzoneLocationInput: ''
                    });
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedLocation({
                            scanLocationId: event.target.value,
                            setScannedLocationIncorrect: setScannedDropzoneLocationIncorrect,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromScreen: 'dropzoneScreen',
                            subscreenName: 'scanFinalTotes',
                            setErrorMsgText: setErrorMsgText,
                            totesList: totesList,
                            setTotesList: setTotesList
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    setScannedDropzoneLocationIncorrect(false);
                    setScannedDropzoneLocationInput(event.target.value);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onScanDropzoneTotesClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.key === 'Enter')) return [3 /*break*/, 2];
                    form.setFieldsValue({
                        scannedTote: ''
                    });
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedTote({
                            scanToteId: event.target.value,
                            setScannedToteIncorrect: setScannedToteIncorrect,
                            totesList: totesList,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            setTotesList: setTotesList,
                            setIsToteScanned: setIsToteScanned,
                            setCheckedContainers: setCheckedContainers,
                            setErrorMsgText: setErrorMsgText,
                            isFromFinalStep: true,
                            fromMoveToSortingScreen: false,
                            subscreenName: 'takeToDropzone'
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    setScannedDropzoneTotesInput('');
                    return [3 /*break*/, 3];
                case 2:
                    setIsToteScanned(false);
                    setScannedToteIncorrect(false);
                    setScannedDropzoneTotesInput(event.target.value);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var setException = function (type) {
        setExceptionConfirmed(true);
        setModalVisible(false);
        setExceptionType(type);
    };
    return (_jsxs("div", __assign({ className: 'px-4 sm:px-8 lg:px-16 pt-1 lg:pt-3 pb-16 h-screen w-full sm:w-4/5 md:w-3/5 lg:w-2/5 mx-auto' }, { children: [_jsx(Modal, __assign({ width: isMobileDevice ? '90%' : '50%', title: t('What is the issue with this product?'), visible: isModalVisible, onCancel: function () { return setModalVisible(false); } }, { children: _jsxs("div", __assign({ className: 'flex flex-col' }, { children: [enumTypeList.map(function (item) {
                            return (_jsx("div", __assign({ className: 'mb-4 w-max mx-auto' }, { children: _jsx(Button, { buttonText: item.description, onClick: function () {
                                        setException(item.description);
                                        setExceptionTypeEnumId(item.enumId);
                                    } }, void 0) }), void 0));
                        }), _jsx("div", __assign({ className: 'mb-4 w-max mx-auto' }, { children: _jsx(Button, { buttonText: t('Cancel'), defaultColor: 'bg-red-500', onClick: function () { return setModalVisible(false); } }, void 0) }), void 0)] }), void 0) }), void 0), _jsx(MainHeading, { heading: t('Pick Multis') }, void 0), currentActiveSubscreen === 'scanCart' ? (_jsxs("div", __assign({ className: 'bg-white p-5 pb-0.5 rounded-lg shadow-sm' }, { children: [_jsx("div", __assign({ className: 'justify-between border-b-2 border-gray-300 my-3' }, { children: _jsx(Heading, { data: localStorage.getItem('pickRunId'), label: t('Pick Run Id') }, void 0) }), void 0), _jsx(Form, __assign({ form: form }, { children: _jsx(Form.Item, __assign({ validateStatus: scannedCartIncorrect ? 'error' : '', help: scannedCartIncorrect && errorMsgText, className: 'w-full', name: 'scannedCart' }, { children: _jsx(Input, { placeholder: '', title: t('Scan Cart'), onKeyDown: onCartScan, value: cartScanInput, onChange: function (e) { return setCartScannedData(e.target.value); }, autoFocus: true, allowClear: true }, void 0) }), void 0) }), void 0)] }), void 0)) : currentActiveSubscreen === 'scanTotes' ? (_jsx("div", { children: _jsxs("div", __assign({ className: 'bg-white p-5 pb-0.5 rounded-lg shadow-sm' }, { children: [_jsxs("div", __assign({ className: 'justify-between border-b-2 border-gray-300 my-3' }, { children: [_jsx(Heading, { data: localStorage.getItem('cartId'), label: t('Cart') }, void 0), _jsx(Heading, { data: localStorage.getItem('pickRunId'), label: t('Pick Run Id') }, void 0)] }), void 0), _jsx(Form, __assign({ form: form }, { children: _jsx(Form.Item, __assign({ validateStatus: scannedToteIncorrect ? 'error' : '', help: scannedToteIncorrect && errorMsgText, className: 'w-full', name: 'scannedTote' }, { children: _jsx(Input, { placeholder: '', title: t('Scan Tote'), onKeyDown: onToteScan, value: toteScanInput, autoFocus: true, allowClear: true }, void 0) }), void 0) }), void 0), requiredPickContainerCount &&
                            new Array(requiredPickContainerCount)
                                .fill(0)
                                .map(function (_, index) {
                                var _a;
                                return (_jsx(ScanTotesForSinglePick, { counter: index + 1, toteData: parsedContainers &&
                                        parsedContainers.length > 0 &&
                                        ((_a = parsedContainers[index]) === null || _a === void 0 ? void 0 : _a.description) }, void 0));
                            })] }), void 0) }, void 0)) : !skipScanLocationScreen && currentActiveSubscreen === 'scanStartLocation' ? (_jsx("div", { children: _jsxs("div", __assign({ className: 'bg-white p-5 pb-0.5 rounded-lg shadow-sm' }, { children: [_jsx(Form, { children: _jsx(Form.Item, __assign({ validateStatus: scannedLocationIncorrect ? 'error' : '', help: scannedLocationIncorrect && errorMsgText, className: 'w-full', name: 'scannedStartLocation' }, { children: _jsx(Input, { placeholder: '', title: t('Scan Start Location'), onKeyDown: onStartLocationScan, value: scannedLocationInput, autoFocus: true, allowClear: true }, void 0) }), void 0) }, void 0), _jsx("h1", __assign({ className: 'mb-2 text-sm text-gray-400 font-semibold' }, { children: t('Scan the nearest location') }), void 0)] }), void 0) }, void 0)) : currentActiveSubscreen === 'scanLocation' ? (_jsx(ScanAgainLocation, { scanCart: cartScannedData, onLocationScanAgain: onLocationScan, errorMsgText: errorMsgText, setCurrentScreen: setCurrentActiveSubscreen, scannedLocationIncorrect: scannedLocationIncorrect, setScannedLocationIncorrect: setScannedLocationIncorrect }, void 0)) : currentActiveSubscreen === 'scanProductUpc' ? (_jsx(ScanProduct, { errorMsgText: errorMsgText, OnProductScan: onProductUpcScan, setErrorMsgText: setErrorMsgText, setCurrentScreen: setCurrentActiveSubscreen, scannedLocationIncorrect: scannedProdUpcIncorrect, setScannedLocationIncorrect: setScannedProdUpcIncorrect, setIsLoading: setIsLoading, from: 'pickMulti' }, void 0)) : currentActiveSubscreen === 'placeInTote' ? (_jsx(PlaceInTote, { currentPickRunTypeId: '', errorMsgText: errorMsgText, setError: setErrorMsgText, onAgainToteScan: onScanToteClick, fromPickMultis: true, scannedLocationIncorrect: scannedToteIncorrect, totesList: totesList, setScannedLocationIncorrect: setScannedToteIncorrect }, void 0)) : currentActiveSubscreen === 'scanDropzoneLocation' ? (_jsxs("div", __assign({ className: 'bg-white p-5 pb-0.5 rounded-lg shadow-sm' }, { children: [_jsxs("div", __assign({ className: 'justify-between border-b-2 border-gray-300 my-3' }, { children: [_jsx(Heading, { data: localStorage.getItem('cartId'), label: t('Cart') }, void 0), _jsx(Heading, { data: localStorage.getItem('pickRunId'), label: t('Pick Run Id') }, void 0)] }), void 0), _jsx("h1", __assign({ className: 'font-bold my-2 text-xs' }, { children: t('Go to Dropzone Location') }), void 0), _jsx("div", __assign({ className: 'flex flex-row' }, { children: _jsxs("table", __assign({ className: ' border-collapse border border-gray-400' }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", __assign({ className: 'border border-gray-400 p-2 text-gray-400 font-medium' }, { children: t('Area') }), void 0), _jsx("th", __assign({ className: 'border border-gray-400 p-2 text-gray-400 font-medium ' }, { children: t('Dropzone') }), void 0)] }, void 0) }, void 0), _jsx("tbody", { children: _jsxs("tr", { children: [_jsx("td", { className: 'border  border-gray-400 text-center' }, void 0), _jsx("td", __assign({ className: 'border border-gray-400 text-center ' }, { children: localStorage.getItem('pickRunDetailsDropzoneId') }), void 0)] }, void 0) }, void 0)] }), void 0) }), void 0), _jsx("div", __assign({ className: 'flex flex-row mt-3' }, { children: _jsx("h1", __assign({ className: 'font-bold my-2 text-xs' }, { children: t('To Drop') }), void 0) }), void 0), parsedContainers &&
                        parsedContainers.length > 0 &&
                        parsedContainers.map(function (item, index) { return (_jsxs("div", __assign({ className: 'flex flex-row items-center' }, { children: [_jsxs("h1", __assign({ className: 'font-semibold text-gray-400 mr-5' }, { children: [t('Tote'), " ", index + 1] }), void 0), _jsx("h1", { children: item.description ? item.description : item.serialNumber }, void 0)] }), void 0)); }), _jsx(Form, __assign({ form: form, className: 'mt-3' }, { children: _jsx(Form.Item, __assign({ validateStatus: scannedDropzoneLocationIncorrect ? 'error' : '', help: scannedDropzoneLocationIncorrect && errorMsgText, className: 'w-full', name: 'scanDropzoneLocationInput' }, { children: _jsx(Input, { placeholder: '', title: t('Scan Dropzone Location'), onKeyDown: onScanDropzoneLocationClick, autoFocus: true, allowClear: true }, void 0) }), void 0) }), void 0)] }), void 0)) : currentActiveSubscreen === 'scanFinalTotes' ? (_jsxs("div", __assign({ className: 'bg-white p-5 pb-0.5 rounded-lg shadow-sm' }, { children: [_jsxs("div", __assign({ className: 'justify-between border-b-2 border-gray-300 my-3' }, { children: [_jsx(Heading, { data: localStorage.getItem('cartId'), label: t('Cart') }, void 0), _jsx(Heading, { data: localStorage.getItem('pickRunDetailsDropzoneId'), label: t('Dropzone') }, void 0), _jsx(Heading, { data: localStorage.getItem('pickRunId'), label: t('Pick Run Id') }, void 0)] }), void 0), _jsx("div", __assign({ className: 'flex flex-row mt-3' }, { children: _jsx("h1", __assign({ className: 'font-bold my-2 text-xs' }, { children: t('Scan Tote') }), void 0) }), void 0), parsedContainers &&
                        parsedContainers.length > 0 &&
                        parsedContainers.map(function (item, index) { return (_jsxs("div", __assign({ className: 'flex flex-row items-center' }, { children: [checkedContainers.includes(item.containerId) ? (_jsx(BsCheckCircleFill, { size: 20, color: '#57bb54' }, void 0)) : (_jsx(IoIosAddCircle, { size: 23, color: '#ed693b' }, void 0)), _jsxs("h1", __assign({ className: 'font-semibold text-gray-400 mr-5 ml-2' }, { children: [t('Tote'), " ", index + 1] }), void 0), _jsx("h1", { children: item.description ? item.description : item.serialNumber }, void 0)] }), void 0)); }), _jsx(Form, __assign({ form: form }, { children: _jsx(Form.Item, __assign({ validateStatus: scannedToteIncorrect ? 'error' : '', help: scannedToteIncorrect && errorMsgText, className: 'w-full', name: 'scannedTote' }, { children: _jsx(Input, { placeholder: '', title: t('Scan Tote'), onKeyDown: onScanDropzoneTotesClick, value: scannedDropzoneTotesInput, autoFocus: true, allowClear: true }, void 0) }), void 0) }), void 0)] }), void 0)) : currentActiveSubscreen === 'takeToDropzone' ? (_jsxs("div", __assign({ className: 'bg-white p-5 rounded-lg shadow-sm' }, { children: [_jsx("h1", __assign({ className: 'font-bold mb-4' }, { children: t('Take all items to dropzone') }), void 0), _jsx("div", __assign({ className: 'flex flex-row items-center justify-between' }, { children: _jsx(Button, { onClick: function () { return setCurrentActiveSubscreen('confirmDrop'); }, buttonText: t('Drop all items') }, void 0) }), void 0)] }), void 0)) : currentActiveSubscreen === 'confirmDrop' ? (_jsxs("div", __assign({ className: 'bg-white p-5 rounded-lg shadow-sm' }, { children: [_jsx("h1", __assign({ className: 'font-bold mb-4' }, { children: t('Confirm dropping all items') }), void 0), _jsxs("div", __assign({ className: 'flex flex-row items-center justify-between' }, { children: [_jsx(Button, { onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    var containers, containerIdsStr, i;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                setIsLoading(true);
                                                containers = localStorage.getItem('pickRunContainerList');
                                                containers = JSON.parse(containers);
                                                containerIdsStr = '';
                                                if (!(containers && containers.length > 0)) return [3 /*break*/, 3];
                                                for (i = 0; i < containers.length; i++) {
                                                    if (containerIdsStr) {
                                                        containerIdsStr += "," + containers[i]['containerId'];
                                                    }
                                                    else {
                                                        containerIdsStr = containers[i]['containerId'];
                                                    }
                                                }
                                                return [4 /*yield*/, dispatch(updatePickrunDropzone())];
                                            case 1:
                                                _a.sent();
                                                return [4 /*yield*/, dispatch(pickMovePickContainer({
                                                        containerId: containerIdsStr,
                                                        continuePickMovePickContainer: continuePickMovePickContainer,
                                                        setContinuePickMovePickContainer: setContinuePickMovePickContainer
                                                    }))];
                                            case 2:
                                                _a.sent();
                                                if (continuePickMovePickContainer) {
                                                    setCurrentActiveSubscreen('confirmedDrop');
                                                }
                                                _a.label = 3;
                                            case 3:
                                                setIsLoading(false);
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }, buttonText: t('Confirm') }, void 0), _jsx(Button, { buttonText: t('Cancel'), onClick: function () { return setCurrentActiveSubscreen('takeToDropzone'); } }, void 0)] }), void 0)] }), void 0)) : (_jsxs("div", __assign({ className: 'bg-white p-5 rounded-lg shadow-sm' }, { children: [_jsx("h1", __assign({ className: 'font-bold mb-4' }, { children: t('Pick complete!') }), void 0), _jsx(Button, { buttonText: t('Done'), onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        localStorage.removeItem('requiredPickContainerCount');
                                        localStorage.removeItem('pickRunContainerList');
                                        localStorage.removeItem('currIndexInPickRunDetailsArr');
                                        localStorage.removeItem('workEffortIdsList');
                                        localStorage.removeItem('pickedItemsArr');
                                        history.push('/');
                                        return [4 /*yield*/, dispatch(updatePickRunStatus({ statusId: 'PrCompleted' }))];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); } }, void 0)] }), void 0))] }), void 0));
};
PickMultis.defaultProps = {
    skipScanLocationScreen: false
};
export default PickMultis;
